import React from 'react';

const CookiePolicyPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">Çerez Politikası</h1>
          <p className="text-xl text-teal-50">Web Sitesi Çerez Kullanımı Hakkında Bilgilendirme</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8">
            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Çerez Nedir?</h2>
                <p className="text-gray-600 leading-relaxed">
                  Çerezler, ziyaret ettiğiniz internet siteleri tarafından tarayıcılar aracılığıyla cihazınıza 
                  veya ağ sunucusuna depolanan küçük metin dosyalarıdır. Çerezler, web sitesinin düzgün 
                  çalışmasını sağlamak, kullanıcı deneyimini geliştirmek ve siteye gelen trafiğin analiz 
                  edilmesine yardımcı olmak için kullanılır.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Çerez Türleri</h2>
                
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">2.1. Zorunlu Çerezler</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Web sitesinin düzgün çalışması için gerekli olan çerezlerdir. Bu çerezler olmadan 
                      sitenin temel işlevleri çalışmayabilir. Oturum yönetimi, güvenlik ve kimlik doğrulama 
                      gibi kritik işlevleri yerine getirirler.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">2.2. İşlevsellik Çerezleri</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Kullanıcı tercihlerinizi hatırlayarak (dil seçimi, font boyutu vb.) web sitesinin 
                      daha kullanışlı hale gelmesini sağlar. Bu çerezler, siteyi tekrar ziyaret ettiğinizde 
                      önceki tercihlerinizin hatırlanmasına yardımcı olur.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">2.3. Performans ve Analitik Çerezleri</h3>
                    <p className="text-gray-600 leading-relaxed">
                      Web sitesinin performansını ve kullanımını analiz etmek için kullanılır. Hangi sayfaların 
                      en çok ziyaret edildiği, kullanıcıların sitede ne kadar zaman geçirdiği gibi bilgileri 
                      toplar. Bu veriler, site deneyimini iyileştirmek için anonim olarak kullanılır.
                    </p>
                  </div>

                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">2.4. Hedefleme/Reklam Çerezleri</h3>
                    <p className="text-gray-600 leading-relaxed">
                      İlgi alanlarınıza uygun reklamları göstermek için kullanılır. Bu çerezler, 
                      ziyaret ettiğiniz sayfalar hakkında bilgi toplar ve bu bilgileri reklam ağları ile paylaşabilir. 
                      Açık rızanız olmadan bu tür çerezler kullanılmaz.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Web Sitemizde Kullanılan Çerezler</h2>
                <div className="overflow-x-auto">
                  <table className="min-w-full bg-white border border-gray-200">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700 border-b">Çerez Adı</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700 border-b">Türü</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700 border-b">Süre</th>
                        <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700 border-b">Amaç</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      <tr>
                        <td className="px-6 py-4 text-sm text-gray-600">session_id</td>
                        <td className="px-6 py-4 text-sm text-gray-600">Zorunlu</td>
                        <td className="px-6 py-4 text-sm text-gray-600">Oturum</td>
                        <td className="px-6 py-4 text-sm text-gray-600">Kullanıcı oturumunu yönetir</td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 text-sm text-gray-600">language</td>
                        <td className="px-6 py-4 text-sm text-gray-600">İşlevsellik</td>
                        <td className="px-6 py-4 text-sm text-gray-600">1 yıl</td>
                        <td className="px-6 py-4 text-sm text-gray-600">Dil tercihini hatırlar</td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 text-sm text-gray-600">_ga</td>
                        <td className="px-6 py-4 text-sm text-gray-600">Analitik</td>
                        <td className="px-6 py-4 text-sm text-gray-600">2 yıl</td>
                        <td className="px-6 py-4 text-sm text-gray-600">Google Analytics - Kullanıcı davranışını analiz eder</td>
                      </tr>
                      <tr>
                        <td className="px-6 py-4 text-sm text-gray-600">cookie_consent</td>
                        <td className="px-6 py-4 text-sm text-gray-600">Zorunlu</td>
                        <td className="px-6 py-4 text-sm text-gray-600">1 yıl</td>
                        <td className="px-6 py-4 text-sm text-gray-600">Çerez tercihlerini saklar</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Çerezleri Nasıl Kontrol Edebilirsiniz?</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Çerez kullanımını kontrol etmek ve yönetmek için aşağıdaki yöntemleri kullanabilirsiniz:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li><strong>Tarayıcı Ayarları:</strong> Tarayıcınızın ayarlar menüsünden çerezleri engelleyebilir, 
                  silebilir veya çerez kullanımı hakkında uyarı alabilirsiniz.</li>
                  <li><strong>Çerez Tercihleri:</strong> Web sitemizin çerez tercih panelindengerekli çerezler dışındaki 
                  çerezleri kabul etmeyebilir veya reddedebilirsiniz.</li>
                  <li><strong>Üçüncü Taraf Araçları:</strong> Bazı üçüncü taraf çerezleri (örneğin Google Analytics) 
                  için ilgili hizmet sağlayıcının web sitesinden çıkış yapabilirsiniz.</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Çerezlerin Reddedilmesinin Etkileri</h2>
                <p className="text-gray-600 leading-relaxed">
                  Zorunlu çerezleri reddetmeniz durumunda web sitesinin bazı özellikleri düzgün çalışmayabilir. 
                  İşlevsellik, performans veya reklam çerezlerini reddetmeniz, site deneyiminizi etkileyebilir 
                  ancak temel işlevlerin kullanımına engel olmaz.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Üçüncü Taraf Çerezleri</h2>
                <p className="text-gray-600 leading-relaxed">
                  Web sitemizde, performans ölçümü ve reklam hizmetleri için üçüncü taraf hizmet sağlayıcıların 
                  çerezleri kullanılabilir. Bu çerezler, ilgili üçüncü tarafların gizlilik politikalarına tabidir. 
                  Kullanılan başlıca üçüncü taraf servisleri:
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4 mt-3">
                  <li>Google Analytics (Web analizi)</li>
                  <li>Google Ads (Reklam hizmetleri)</li>
                  <li>Sosyal medya eklentileri (paylaşım butonları)</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Politika Güncellemeleri</h2>
                <p className="text-gray-600 leading-relaxed">
                  Bu Çerez Politikası, yasal gerekliliklere uyum sağlamak veya hizmetlerimizi geliştirmek 
                  amacıyla zaman zaman güncellenebilir. Önemli değişiklikler olması durumunda, web sitesi 
                  üzerinden veya e-posta yoluyla bilgilendirilirsiniz.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold text-gray-900 mb-4">8. İletişim</h2>
                <p className="text-gray-600 leading-relaxed">
                  Çerez Politikamız hakkında sorularınız için bizimle iletişime geçebilirsiniz:
                </p>
                <p className="text-gray-600 mt-3">
                  <strong>E-posta:</strong> destek@clndonlinesube.com
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg mt-8">
                <p className="text-sm text-gray-600">
                  <strong>Not:</strong> Web sitemizi kullanmaya devam ederek, bu Çerez Politikasında 
                  belirtilen şartları kabul etmiş sayılırsınız. Çerez tercihlerinizi istediğiniz zaman 
                  değiştirebilirsiniz.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CookiePolicyPage;
